module.exports = __webpack_public_path__ + "img/img02.c0183458.png";